// tslint:disable
export var ProgramPartyType;
(function (ProgramPartyType) {
    // UNKN
    ProgramPartyType[ProgramPartyType["UNKNOWN"] = 0] = "UNKNOWN";
    // P
    ProgramPartyType[ProgramPartyType["PERSON"] = 1] = "PERSON";
    // O
    ProgramPartyType[ProgramPartyType["ORGANIZATION"] = 2] = "ORGANIZATION";
    // OTH
    ProgramPartyType[ProgramPartyType["OTHERS"] = 3] = "OTHERS";
    // Empty
    ProgramPartyType[ProgramPartyType["PlaceholderForNonentity"] = 4] = "PlaceholderForNonentity";
})(ProgramPartyType || (ProgramPartyType = {}));
ProgramPartyType['PLACEHOLDERFORNONENTITY'] = 4;
//# sourceMappingURL=ProgramPartyType.js.map